// Irrigated switch. The other Overview strings come from gw-js-lib (sensors.*).
export default {
  en: {
    irr: {
      label: 'Irrigated',
      detected: 'Regular watering detected: {n} of the last {window} days, mostly from {from}.',
      notDetected: 'No regular watering detected.',
      confirmedOn: 'Set to irrigated by {name} on {date}.',
      confirmedOff: 'Set to not irrigated by {name} on {date}.',
      confirm: 'Confirm',
      useAuto: 'Use detection',
      saved: 'Saved. The forecast uses it from its next update (within 6 hours).',
    },
  },
  es: {
    irr: {
      label: 'Con riego',
      detected: 'Riego regular detectado: {n} de los últimos {window} días, sobre todo desde las {from}.',
      notDetected: 'No se detecta riego regular.',
      confirmedOn: 'Marcado con riego por {name} el {date}.',
      confirmedOff: 'Marcado sin riego por {name} el {date}.',
      confirm: 'Confirmar',
      useAuto: 'Usar detección',
      saved: 'Guardado. El pronóstico lo usa desde su próxima actualización (en menos de 6 horas).',
    },
  },
};
